<template lang="html">
  <info-icon
    :icon="icon"
    :color="color"
    :message="message"/>
</template>

<script>
import InfoIcon from './InfoIcon'
export default {
  components: {
    'info-icon': InfoIcon
  },
  data: () => ({
    icon: 'mdi-check-all',
    color: 'success',
    message: 'Trip has been booked'
  })
}
</script>

<style lang="css" scoped>
</style>
